import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { DATA } from '../data/data';
import { ApiService } from './api.service';
import { FlatroofZoningRooms } from '../model/flatroof-zoning-rooms';
import { ZonesPropertiesService } from './zones-properties.service';
import { SCALE } from '../data/scale';
import { ElementsService } from './elements.service';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  constructor(
    private apiService: ApiService,
    private zonePropertiesService: ZonesPropertiesService,
    private elementsService: ElementsService
    ) { 
      this._currentData=DATA;
    //   this.apiService.getRoomsList().subscribe((rooms: FlatroofZoningRooms[])=>{
      
    //   this.populateRoomsDataFromDb(rooms)
    //   ;
    // })
  }

  private _dataSource: Subject<any> = new Subject();
  private _currentData: any;
  data$ = this._dataSource.asObservable();

  get dataSource(): Subject<any> {
    return this._dataSource;
  }
  set dataSource(data: Subject<any>) {
    this._dataSource = data;
  }

  get currentData(): any {
    return this._currentData;
  }
  set currentData(options: any) {
    this._currentData = options;
  }
  populateRoomsDataFromDb(){
    this.apiService.getRoomsList().subscribe((rooms: FlatroofZoningRooms[])=>{
      this.currentData.roomsData=rooms;
      this.populateRoomsData(rooms)
    })
  }
  
  populateRoomsData(rooms:FlatroofZoningRooms[]){
    this._currentData.options.roomTypes=[]
    for(let i=0;i<rooms.length;i++){
      this._currentData.options.roomTypes.push({value:rooms[i].id,viewValue:rooms[i].room})
    }
    this.dataSource.next(this._currentData);
    
  }
  
  calculateArea(points){
    let arrays=this.createCoordsArrays(points);
    
    let a = this.polygonArea(arrays.x, arrays.y, points.length-1);
    ;
    return a;
  }

  createCoordsArrays(points){
    let x=[];
    let y=[];
    
    //pomija ostatni punkt bo ostatni jest zamykajacy a wiec taki sam jak pierwszy
    for(let i=0;i<points.length-1;i++){
      x.push(points[i].x)
      y.push(points[i].y)
    }

    return {x:x,y:y}
  }

  polygonArea(X, Y, numPoints) 
  { 
    let area = 0;         // Accumulates area in the loop
    let j = numPoints-1;  // The last vertex is the 'previous' one to the first
  
    for (let i=0; i<numPoints; i++)
      { area = area +  (X[j]+X[i]) * (Y[j]-Y[i]); 
        j = i;  //j is previous vertex to i
      }

      return Math.abs(Math.round((area/2)*(SCALE.screen.default.metersPerPx*SCALE.screen.default.metersPerPx)*100)/100);
  }
  
  getRoomsAsObject(){
    let rooms=this._currentData.options.roomTypes;
    let oRooms={};
    for(let i=0;i<rooms.length;i++){
      oRooms[rooms[i].value]=rooms[i].viewValue
    }
    return oRooms;
  }

  getDataFromDb(){
    this.apiService.getData().subscribe((data: any)=>{  
      this.currentData.mainData=data; 
      let materials=this.getMaterials(data) 
      let populatedMaterialsData=this.populateMaterialsData(materials)
      let result=this.createResultsJson(populatedMaterialsData);
      this.currentData.results=result
      ;
      this._dataSource.next(this._currentData);
    })    
  }
  getMinSameThickness(rawResults){
    let zones=this.zonePropertiesService.zonesProperties;
    let minThickness=150;
    for(let j=zones.length-1;j>0;j--){
      if(rawResults[zones[j].id].thickness && minThickness<rawResults[zones[j].id].thickness){
        minThickness=rawResults[zones[j].id].thickness;
      }
    }

    return minThickness
  }
  createResultsJson(rawResults){    
    let zones=this.zonePropertiesService.zonesProperties;
    let result={};
    let materialName:string;
    let thickness:number=this.getMinSameThickness(rawResults);
    
    for(let j=zones.length-1;j>0;j--){
      let properties:any={};
      if(rawResults[zones[j].id].material_type == 1){
        materialName='Hardrock (DD) TRB'
      }else if(rawResults[zones[j].id].material_type == 0){
        materialName='Hardrock Multi-Fix';
      }else if(rawResults[zones[j].id].material_type == 2){
        materialName='Hardrock Terrace';
      }
      // if(rawResults[zones[j].id].isTRB){
      //   materialName='Hardrock (DD) TRB'
      // }else{
      //   materialName='Hardrock Multi-Fix';
      // }
      // jesli null to znaczy ze wyszlo poza skale z dolu wiec ustawiam najcienszy dach
      // thickness=rawResults[zones[j].id].thickness?rawResults[zones[j].id].thickness:150;

      if(!zones[j].thermal.ifActive || ( zones[0].thermal.ifActive && zones[0].thermal.selected!=null)){        
        properties.thermal=null;
      }else{
        properties.thermal=zones[j].thermal.selected
      }
      
      if(!zones[j].acoustic.ifActive || ( zones[0].acoustic.ifActive && zones[0].acoustic.selected!=null)){        
        properties.acoustic=null;
      }else{
        properties.acoustic=zones[j].acoustic.selected
      }

      
      if(!zones[j].pointLoad.ifActive || ( zones[0].pointLoad.ifActive && zones[0].pointLoad.selected!=null)){        
        properties.pointLoad=null;
      }else{
        properties.pointLoad=zones[j].pointLoad.selected
      }
      

      if(!zones[j].compresiveStrength.ifActive || (zones[0].compresiveStrength.ifActive && zones[0].compresiveStrength.selected!=null)){        
        properties.compresiveStrength=null;
      }else{
        properties.compresiveStrength=zones[j].compresiveStrength.selected
      }
      

      if(!zones[j].rainNoise.ifActive || ( zones[0].rainNoise.ifActive && zones[0].rainNoise.selectedRoom!=null && zones[0].rainNoise.selectedWork!=null && zones[0].rainNoise.roomHeight!=null)){        
        properties.rainNoise=null;
      }else if(zones[j].rainNoise.ifActive && zones[j].rainNoise.selectedRoom!=null && zones[j].rainNoise.selectedWork!=null && zones[j].rainNoise.roomHeight!=null){
        properties.rainNoise={};
        properties.rainNoise.selectedRoom=zones[j].rainNoise.selectedRoom
        properties.rainNoise.selectedWork=zones[j].rainNoise.selectedWork
        properties.rainNoise.roomHeight=zones[j].rainNoise.roomHeight
      }else{
        properties.rainNoise=null;
      }
      

      result[zones[j].id]={materialName:thickness+'mm '+materialName,properties:properties,thickness:thickness}
    }
    let properties:any={};
    if(zones[0].thermal.ifActive && zones[0].thermal.selected!=null){ 
      properties.thermal=zones[0].thermal.selected 
    }else{      
      properties.thermal=null;
    }

    if(zones[0].acoustic.ifActive && zones[0].acoustic.selected!=null){     
      properties.acoustic=zones[0].acoustic.selected
    }else{   
      properties.acoustic=null;
    }

    if(zones[0].pointLoad.ifActive && zones[0].pointLoad.selected!=null){ 
      properties.pointLoad=zones[0].pointLoad.selected  
    }else{     
      properties.pointLoad=null;
    }

    if(zones[0].compresiveStrength.ifActive && zones[0].compresiveStrength.selected!=null){  
      properties.compresiveStrength=zones[0].compresiveStrength.selected   
    }else{   
      properties.compresiveStrength=null;
    }

    if(zones[0].rainNoise.ifActive && zones[0].rainNoise.selectedRoom!=null && zones[0].rainNoise.selectedWork!=null && zones[0].rainNoise.roomHeight!=null){              
      properties.rainNoise={};
      properties.rainNoise.selectedRoom=zones[0].rainNoise.selectedRoom
      properties.rainNoise.selectedWork=zones[0].rainNoise.selectedWork
      properties.rainNoise.roomHeight=zones[0].rainNoise.roomHeight
    }else{
      properties.rainNoise=null;
    }
    result[zones[0].id]={materialName:null,properties:properties,thickness:thickness}
    return result;
  }

  populateMaterialsData(materials){
    let zones=this.zonePropertiesService.zonesProperties;
    let maxThickness=null;
    if(materials[zones[0].id].isTRB){
      materials[zones[0].id].thickness=materials[zones[0].id].combinedU;
      maxThickness=materials[zones[0].id].combinedU;
    }else{
      materials[zones[0].id].thickness=this.getHighestValue([materials[zones[0].id].combinedU,materials[zones[0].id].rainNoise,materials[zones[0].id].acoustic])
      maxThickness=materials[zones[0].id].thickness
    }

    for(let j=zones.length-1;j>0;j--){
      if(!materials[zones[0].id].isTRB) 
        materials[zones[j].id].isTRB=false

      if(zones[0].thermal.ifActive && zones[0].thermal.selected!=null){
        materials[zones[j].id].thermalTRB=0;
        materials[zones[j].id].thermalHRMF=0
      }
      if(zones[0].rainNoise.ifActive && zones[0].rainNoise.selectedRoom!=null && zones[0].rainNoise.selectedWork!=null && zones[0].rainNoise.roomHeight!=null){
        materials[zones[j].id].rainNoise=0;
      }

      if(zones[0].acoustic.ifActive && zones[0].acoustic.selected!=null){
        materials[zones[j].id].acoustic=0;
      }

      if(materials[zones[j].id].isTRB){
        if(maxThickness<materials[zones[j].id].thermalTRB){
          maxThickness=materials[zones[j].id].thermalTRB
        }        
        materials[zones[j].id].thickness=maxThickness;
      }else{
        let highestVal=this.getHighestValue([materials[zones[j].id].thermalHRMF,materials[zones[j].id].rainNoise,materials[zones[j].id].acoustic])
        if(maxThickness<highestVal){
          maxThickness=highestVal
        } 
        materials[zones[j].id].thickness=maxThickness
      }
    }
    return materials;
  }

  getLowestValue(values){
    let minVal;
    for(let i=0;i<values.length;i++){
      if(!minVal || minVal>values[i]){
        minVal=values[i]
      }
    }
    return minVal;
  }

  getHighestValue(values){
    let maxVal;
    for(let i=0;i<values.length;i++){
      if(!maxVal || maxVal<values[i]){
        maxVal=values[i]
      }
    }
    return maxVal;
  }

  getMaterials(data){
    let zones=this.zonePropertiesService.zonesProperties;
    let HRMFAreas: number = 0;
    let TRBAreas: number = 0;
    let TerraceAreas: number = 0;
    let thermalHRMF, thermalTRB, thermalTerrace, acoustic, maxPredicted, rainNoise;

    let materials={}
    //iteracja po zonach
    for(let j=zones.length-1;j>0;j--){ 
      thermalHRMF=thermalTRB=maxPredicted=rainNoise=acoustic=null;
      let reverbTime, ianl;
      let zone = this.elementsService.getZoneById(zones[j].id)
      let isTRB:boolean=this.ifTRB(zones[j]);
      let material_type: number = this.getMeterialId(zones[j]);

      let currentArea=this.calculateArea(zone.points);

      if(material_type == 0){
        HRMFAreas += currentArea;
      }else if(material_type == 1){
        TRBAreas += currentArea;
      }else if(material_type == 2){        
        TerraceAreas += currentArea;
      }

      if(zones[j].rainNoise.ifActive && zones[j].rainNoise.selectedRoom!=null && zones[j].rainNoise.selectedWork!=null){
        
        let selectedRoom=this.findInArrayById(this.currentData.roomsData,zones[j].rainNoise.selectedRoom);
        if(zones[j].rainNoise.selectedWork==0){
          reverbTime=selectedRoom.reverb_time_new;
          ianl=selectedRoom.max_ianl_new
        }else{
          reverbTime=selectedRoom.reverb_time_refurb;
          ianl=selectedRoom.max_ianl_refurb
        }        
      }
      
      let rainNoiseDB={}
      //iteracje po wierszach tabeli z bazy danych    
      for(let i=0;i<data.length;i++){

        if( zones[j].thermal.ifActive && zones[j].thermal.selected!=null){          
          let thermalValue=this.getDataOptionByValue('thermals',zones[j].thermal.selected).value;
          if((!thermalHRMF || data[i].thickness<thermalHRMF) && data[i].u_hrmf==thermalValue){
            thermalHRMF=data[i].thickness;
          }
          if((!thermalTRB || data[i].thickness<thermalTRB) && data[i].u_trb==thermalValue){
            thermalTRB=data[i].thickness;
          }
          if((!thermalTerrace || data[i].thickness<thermalTerrace) && data[i].u_terrace==thermalValue){
            thermalTerrace=data[i].thickness;
          }
        }else if(!zones[j].thermal.ifActive || zones[j].thermal.selected==null){
          
          if(!thermalHRMF || data[i].thickness<thermalHRMF){
            thermalHRMF=data[i].thickness;
          }
          if(!thermalTRB || data[i].thickness<thermalTRB){
            thermalTRB=data[i].thickness;
          }
          if(!thermalTerrace || data[i].thickness<thermalTerrace){
            thermalTerrace=data[i].thickness;
          }
        }
        
        if(zones[j].acoustic.ifActive && zones[j].acoustic.selected!=null){   
               
          let acousticValue=this.getDataOptionByValue('acoustics',zones[j].acoustic.selected).value;
            
          if((!acoustic || data[i].thickness<acoustic) && data[i].airborne_hrmf==acousticValue){
            acoustic=data[i].thickness;
          }
        }else if(!zones[j].acoustic.ifActive || zones[j].acoustic.selected==null){
          if(!acoustic || data[i].thickness<acoustic){
            acoustic=data[i].thickness;
          }
        }

        if(zones[j].rainNoise.ifActive && zones[j].rainNoise.selectedRoom!=null && zones[j].rainNoise.selectedWork!=null){
          
          rainNoiseDB['hrmf_rain_noise_125']=this.countRainNoise_125(data[i].hrmf_rain_noise_125,currentArea,zones[j].rainNoise.roomHeight,reverbTime)
          rainNoiseDB['hrmf_rain_noise_250']=this.countRainNoise_250(data[i].hrmf_rain_noise_250,currentArea,zones[j].rainNoise.roomHeight,reverbTime)
          rainNoiseDB['hrmf_rain_noise_500']=this.countRainNoise_500(data[i].hrmf_rain_noise_500,currentArea,zones[j].rainNoise.roomHeight,reverbTime)
          rainNoiseDB['hrmf_rain_noise_1000']=this.countRainNoise_1000(data[i].hrmf_rain_noise_1000,currentArea,zones[j].rainNoise.roomHeight,reverbTime)
          rainNoiseDB['hrmf_rain_noise_2000']=this.countRainNoise_2000(data[i].hrmf_rain_noise_2000,currentArea,zones[j].rainNoise.roomHeight,reverbTime)
          rainNoiseDB['hrmf_rain_noise_4000']=this.countRainNoise_4000(data[i].hrmf_rain_noise_4000,currentArea,zones[j].rainNoise.roomHeight,reverbTime)
          
          data[i].predicted_sound_pressure=Math.round(
                                            10*Math.log10(
                                              Math.pow(10,(rainNoiseDB['hrmf_rain_noise_125']/10))+
                                              Math.pow(10,(rainNoiseDB['hrmf_rain_noise_250']/10))+
                                              Math.pow(10,(rainNoiseDB['hrmf_rain_noise_500']/10))+
                                              Math.pow(10,(rainNoiseDB['hrmf_rain_noise_1000']/10))+
                                              Math.pow(10,(rainNoiseDB['hrmf_rain_noise_2000']/10))+
                                              Math.pow(10,(rainNoiseDB['hrmf_rain_noise_4000']/10))
                                              )
                                            );

          if((!maxPredicted || maxPredicted<data[i].predicted_sound_pressure) && ianl>data[i].predicted_sound_pressure){ 
            maxPredicted=data[i].predicted_sound_pressure;
            rainNoise=data[i].thickness
          }else if(ianl==data[i].predicted_sound_pressure){
            rainNoise=data[i].thickness;
          }

        }else{
          if(!rainNoise || data[i].thickness<rainNoise){
            rainNoise=data[i].thickness;
          }
        }
        
      }

      materials[zones[j].id]={isTRB:isTRB, material_type: material_type, thermalHRMF:thermalHRMF, thermalTRB:thermalTRB, thermalTerrace: thermalTerrace, reverbTime:reverbTime, ianl:ianl,rainNoise:rainNoise,acoustic:acoustic}

    }
    // GLOBAL
    thermalHRMF=thermalTRB=maxPredicted=rainNoise=acoustic=null;
      let reverbTime, ianl;
      let zone = this.elementsService.getZoneById(-1)
      let isTRB:boolean=this.ifTRB(zones[0])
      let material_type: number = this.getMeterialId(zones[0]);
     

      if(zones[0].rainNoise.ifActive && zones[0].rainNoise.selectedRoom!=null && zones[0].rainNoise.selectedWork!=null){
        
        let selectedRoom=this.findInArrayById(this.currentData.roomsData,zones[0].rainNoise.selectedRoom);
        if(zones[0].rainNoise.selectedWork==0){
          reverbTime=selectedRoom.reverb_time_new;
          ianl=selectedRoom.max_ianl_new
        }else{
          reverbTime=selectedRoom.reverb_time_refurb;
          ianl=selectedRoom.max_ianl_refurb
        }        
      }
      
      let rainNoiseDB={}
      //iteracje po wierszach tabeli z bazy danych    
      for(let i=0;i<data.length;i++){
        if( zones[0].thermal.ifActive && zones[0].thermal.selected!=null){          
          let thermalValue=this.getDataOptionByValue('thermals',zones[0].thermal.selected).value;
          let combinedU=Math.round(((data[i].u_hrmf*HRMFAreas)+(data[i].u_trb*TRBAreas)+(data[i].u_terrace*TerraceAreas))/(HRMFAreas+TRBAreas+TerraceAreas)*100)/100
          if((!thermalHRMF || data[i].thickness<thermalHRMF) && combinedU==thermalValue){
            thermalHRMF=data[i].thickness;
          }
        }else if(!zones[0].thermal.ifActive || zones[0].thermal.selected==null){
          if(!thermalHRMF || data[i].thickness<thermalHRMF){
            thermalHRMF=data[i].thickness;
          }
        }
        
        if(zones[0].acoustic.ifActive && zones[0].acoustic.selected!=null){          
          let acousticValue=this.getDataOptionByValue('acoustics',zones[0].acoustic.selected).value;
          if((!acoustic || data[i].thickness<acoustic) && data[i].airborne_hrmf==acousticValue){
            acoustic=data[i].thickness;
          }
        }else if(!zones[0].acoustic.ifActive || zones[0].acoustic.selected==null){
          if(!acoustic || data[i].thickness<acoustic){
            acoustic=data[i].thickness;
          }
        }

        if(zones[0].rainNoise.ifActive && zones[0].rainNoise.selectedRoom!=null && zones[0].rainNoise.selectedWork!=null){
          
          rainNoiseDB['hrmf_rain_noise_125']=this.countRainNoise_125(data[i].hrmf_rain_noise_125,HRMFAreas,zones[0].rainNoise.roomHeight,reverbTime)
          rainNoiseDB['hrmf_rain_noise_250']=this.countRainNoise_250(data[i].hrmf_rain_noise_250,HRMFAreas,zones[0].rainNoise.roomHeight,reverbTime)
          rainNoiseDB['hrmf_rain_noise_500']=this.countRainNoise_500(data[i].hrmf_rain_noise_500,HRMFAreas,zones[0].rainNoise.roomHeight,reverbTime)
          rainNoiseDB['hrmf_rain_noise_1000']=this.countRainNoise_1000(data[i].hrmf_rain_noise_1000,HRMFAreas,zones[0].rainNoise.roomHeight,reverbTime)
          rainNoiseDB['hrmf_rain_noise_2000']=this.countRainNoise_2000(data[i].hrmf_rain_noise_2000,HRMFAreas,zones[0].rainNoise.roomHeight,reverbTime)
          rainNoiseDB['hrmf_rain_noise_4000']=this.countRainNoise_4000(data[i].hrmf_rain_noise_4000,HRMFAreas,zones[0].rainNoise.roomHeight,reverbTime)
          
          data[i].predicted_sound_pressure=Math.round(
                                            10*Math.log10(
                                              Math.pow(10,(rainNoiseDB['hrmf_rain_noise_125']/10))+
                                              Math.pow(10,(rainNoiseDB['hrmf_rain_noise_250']/10))+
                                              Math.pow(10,(rainNoiseDB['hrmf_rain_noise_500']/10))+
                                              Math.pow(10,(rainNoiseDB['hrmf_rain_noise_1000']/10))+
                                              Math.pow(10,(rainNoiseDB['hrmf_rain_noise_2000']/10))+
                                              Math.pow(10,(rainNoiseDB['hrmf_rain_noise_4000']/10))
                                              )
                                            );

          if((!maxPredicted || maxPredicted<data[i].predicted_sound_pressure) && ianl>data[i].predicted_sound_pressure){ 
            maxPredicted=data[i].predicted_sound_pressure;
            rainNoise=data[i].thickness
          }else if(ianl==data[i].predicted_sound_pressure){
            rainNoise=data[i].thickness;
          }

        }else{
          if(!rainNoise || data[i].thickness<rainNoise){
            rainNoise=data[i].thickness;
          }
        }
        
      }

      materials[zones[0].id]={isTRB:isTRB, material_type: material_type, combinedU:thermalHRMF, reverbTime:reverbTime, ianl:ianl,rainNoise:rainNoise}
      
      return materials;
  }
  /**
   * 0 Multi-Fix
   * 2 Terrace
   */
  getMeterialId(zone): number{
    let material = 0;
    if (zone.type == 1) {
      material = 0;
    }else if (zone.type == 2) {
      material = 2;
    }else if(!zone.rainNoise.ifActive && !zone.acoustic.ifActive){
      // if (zone.compresiveStrength.ifActive && zone.compresiveStrength.selected<=30) {
      //   material = 1;
      // }else 
      if (zone.compresiveStrength.ifActive && zone.compresiveStrength.selected>65) {
        material = 2;
      // }else if(!zone.compresiveStrength.ifActive || zone.compresiveStrength.selected==null) {
      //   material = 1;
      } else {
        material = 0;
      }

      // if(zone.pointLoad.ifActive && zone.pointLoad.selected<=450) {
      //   material = material == 1 ? 1 : material;
      // } else 
      if(zone.pointLoad.ifActive && zone.pointLoad.selected>650) {
        material = 2
      } else if(!zone.pointLoad.ifActive || zone.pointLoad.selected==null) {
        material =  material == 0 ? 0 : material;
      }else {
        material = material == 0 ? 0 : material;
      }
    }
    return material;
  }

  ifTRB(zone):boolean{
    if(zone.type==1){
      return false;
    }else if(!zone.rainNoise.ifActive && !zone.acoustic.ifActive){
        let isTRB=false;
        
        if(zone.compresiveStrength.ifActive && zone.compresiveStrength.selected<=30)
          isTRB=true;
        else if(!zone.compresiveStrength.ifActive || zone.compresiveStrength.selected==null)
          isTRB=true;        
        else
          isTRB=false
        
        if(zone.pointLoad.ifActive && zone.pointLoad.selected<=450)
          isTRB=true && isTRB;
        else if(!zone.pointLoad.ifActive || zone.pointLoad.selected==null)
          isTRB=true && isTRB;
        else
          isTRB=false
        return isTRB;      
      
    }    
    return false;
  }

  getThermalHRMF(data){
    let thermalHRMF;
    let thermalTRB;
    let thermalTerrace;
    let thermalCombined;
    let acoustic;
    let rainNoise;
    let rainNoiseDB={}
    let zones=this.zonePropertiesService.zonesProperties;
    
    
    for(let j=zones.length-1;j>0;j--){
    let reverbTime, ianl;
      if(zones[j].rainNoise.ifActive && zones[j].rainNoise.selectedRoom!=null && zones[j].rainNoise.selectedWork!=null){
        
        let selectedRoom=this.findInArrayById(this.currentData.roomsData,zones[j].rainNoise.selectedRoom);
        if(zones[j].rainNoise.selectedWork==0){
          reverbTime=selectedRoom.reverb_time_new;
          ianl=selectedRoom.max_ianl_new
        }else{
          reverbTime=selectedRoom.reverb_time_refurb;
          ianl=selectedRoom.max_ianl_refurb
        }
      }
      let zoneArea=this.calculateArea(zones[j]);
      let ianlMax;
      for(let i=0;i<data.length;i++){
        
        if( zones[j].thermal.ifActive && zones[j].thermal.selected!=null){
          let thermalValue=this.getDataOptionByValue('thermals',zones[j].thermal.selected).value
          if((!thermalHRMF || data[i].thickness<thermalHRMF) && data[i].u_hrmf==thermalValue){
            thermalHRMF=data[i].thickness;
          }
          if((!thermalTRB || data[i].thickness<thermalTRB) && data[i].u_trb==thermalValue){
            thermalTRB=data[i].thickness;
          }
          if((!thermalTerrace || data[i].thickness<thermalTerrace) && data[i].u_terrace==thermalValue){
            thermalTerrace=data[i].thickness;
          }
          if((!thermalCombined || data[i].thickness<thermalCombined) && data[i].u_combination==thermalValue){
            thermalCombined=data[i].thickness;
          }
        }
        if(zones[j].acoustic.ifActive && zones[j].acoustic.selected!=null){
          if((!acoustic || data[i].thickness<acoustic) && data[i].airborne_hrmf==this.getDataOptionByValue('acoustics',zones[j].acoustic.selected).value){
            acoustic=data[i].thickness;
          }
        }

        if(zones[j].rainNoise.ifActive && zones[j].rainNoise.selectedRoom!=null && zones[j].rainNoise.selectedWork!=null){
          
          rainNoiseDB['hrmf_rain_noise_125']=this.countRainNoise_125(data[i].hrmf_rain_noise_125,10,zones[j].rainNoise.roomHeight,1.2)
          rainNoiseDB['hrmf_rain_noise_250']=this.countRainNoise_250(data[i].hrmf_rain_noise_250,10,zones[j].rainNoise.roomHeight,1.2)
          rainNoiseDB['hrmf_rain_noise_500']=this.countRainNoise_500(data[i].hrmf_rain_noise_500,10,zones[j].rainNoise.roomHeight,1.2)
          rainNoiseDB['hrmf_rain_noise_1000']=this.countRainNoise_1000(data[i].hrmf_rain_noise_1000,10,zones[j].rainNoise.roomHeight,1.2)
          rainNoiseDB['hrmf_rain_noise_2000']=this.countRainNoise_2000(data[i].hrmf_rain_noise_2000,10,zones[j].rainNoise.roomHeight,1.2)
          rainNoiseDB['hrmf_rain_noise_4000']=this.countRainNoise_4000(data[i].hrmf_rain_noise_4000,10,zones[j].rainNoise.roomHeight,1.2)
          
        //   if(ianl!=undefined &&  ianl>data[i].predicted_sound_pressure){
        //     if(!ianlMax || ianlMax<data[i].predicted_sound_pressure){
        //       ianlMax=data[i].predicted_sound_pressure;
        //       rainNoise=data[i].thickness;
        //     }

        //   }else if(ianl!=undefined &&  ianl<=data[i].predicted_sound_pressure){
        //     if(ianl==data[i].predicted_sound_pressure){              
        //       ianlMax=data[i].predicted_sound_pressure;
        //       rainNoise=data[i].thickness;
        //     }
        //   }
        }
        
      }
    }

    
  }

  countRainNoise_125(rainNoise,areaHRMF,height,time){
    rainNoise=parseFloat(rainNoise)
    areaHRMF=parseFloat(areaHRMF)
    height=parseFloat(height)
    time=parseFloat(time)
    return rainNoise + 10*Math.log10(areaHRMF) + 10*Math.log10( (4*(1.3*time) ) / (0.16*areaHRMF*height) )-16.1
  }

  countRainNoise_250(rainNoise,areaHRMF,height,time){
    rainNoise=parseFloat(rainNoise)
    areaHRMF=parseFloat(areaHRMF)
    height=parseFloat(height)
    time=parseFloat(time)
    return rainNoise+10*Math.log10(areaHRMF)+10*Math.log10((4*(1.3*time))/(0.16*areaHRMF*height))-8.6
  }

  countRainNoise_500(rainNoise,areaHRMF,height,time){
    rainNoise=parseFloat(rainNoise)
    areaHRMF=parseFloat(areaHRMF)
    height=parseFloat(height)
    time=parseFloat(time)
    return rainNoise+10*Math.log10(areaHRMF)+10*Math.log10((4*time)/(0.16*areaHRMF*height))-3.2
  }

  countRainNoise_1000(rainNoise,areaHRMF,height,time){
    rainNoise=parseFloat(rainNoise)
    areaHRMF=parseFloat(areaHRMF)
    height=parseFloat(height)
    time=parseFloat(time)
    return rainNoise+10*Math.log10(areaHRMF)+10*Math.log10((4*time)/(0.16*areaHRMF*height))
  }

  countRainNoise_2000(rainNoise,areaHRMF,height,time){
    rainNoise=parseFloat(rainNoise)
    areaHRMF=parseFloat(areaHRMF)
    height=parseFloat(height)
    time=parseFloat(time)
    return rainNoise+10*Math.log10(areaHRMF)+10*Math.log10((4*time)/(0.16*areaHRMF*height))+1.2
  }

  countRainNoise_4000(rainNoise,areaHRMF,height,time){
    rainNoise=parseFloat(rainNoise)
    areaHRMF=parseFloat(areaHRMF)
    height=parseFloat(height)
    time=parseFloat(time)
    return rainNoise+10*Math.log10(areaHRMF)+10*Math.log10((4*time)/(0.16*areaHRMF*height))+1
  }

  findInArrayById(table,id){
    for(let i=0;i<table.length;i++)
      if(table[i].id==id)
        return table[i]

    return null;
  }

  getDataOptionByValue(type:string,value:number){
    for(let i=0;i<this.currentData.options[type].length;i++)
      if(this.currentData.options[type][i].value==value)
        return this.currentData.options[type][i]

      return null;
  }

}
